import React from 'react'
import { match } from 'ts-pattern'

import { VerifierType } from '@frame/lib/api/common/types'
import { useStore } from '@frame/lib/stores/useStore'

import { Documents } from '../index'
import { TenantDocuments } from '../tenant-documents'

export function DocumentsV2() {
  const verifierType = useStore(({ session }) => session?.verifier_type)

  return match(verifierType)
    .with(VerifierType.TENANT, () => <TenantDocuments />)
    .otherwise(() => <Documents />)
}
